import { Box, InputProps } from "@chakra-ui/react";
import formElements from "@shared/theme/props/formElements";
import { forwardRef } from "react";
import PhoneInput from "react-phone-input-2";
import usePhoneNumberInput from "./hooks/usePhoneNumberInput";
import type { PhoneNumberInputSharedProps } from "./PhoneNumberInput.props";
import "./PhoneNumberInput.css";

const { height } = formElements;

export type PhoneNumberInputProps = PhoneNumberInputSharedProps &
  InputProps & {
    "data-testid"?: string;
  };

const PhoneNumberInput = forwardRef<HTMLInputElement, PhoneNumberInputProps>(
  function forwardInputRef(
    props: PhoneNumberInputProps,
    _ref: React.Ref<HTMLInputElement>
  ) {
    const { placeholder, phoneInput, countryInput, handleSetPhone } = props;
    const { selectedCountry, handleChange } = usePhoneNumberInput(
      handleSetPhone,
      countryInput
    );

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        // Trigger form submission
        event.preventDefault();
        const form = event.currentTarget.closest("form");
        if (form) {
          form.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }
      }
    };

    // if a country is passed in, use that value
    // else use the default, "ca"
    const countryToUse = countryInput ?? selectedCountry;

    return (
      <Box
        data-testid={props["data-testid"]}
        width="100%"
        className="phone-input-wrapper"
        style={{ "--input-height": height } as React.CSSProperties}
      >
        <PhoneInput
          {...props}
          key={countryInput?.countryCode || "default"}
          aria-label="phone number input"
          placeholder={placeholder}
          country={countryToUse.countryCode || "ca"}
          preferredCountries={["au", "ca", "gb", "us"]}
          disableCountryGuess
          value={phoneInput}
          autoFormat
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
      </Box>
    );
  }
);

export default PhoneNumberInput;
